module.exports = __webpack_public_path__ + "img/cncpic.a5bd55d3.png";